import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  Table,
  Badge,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  CardBody,
  Modal,
} from "reactstrap";
// core components
import NumberFormat from 'react-number-format';
import Header from "components/Headers/CreditHistoryHeader";
import CreditDataService from "../../services/CreditDataService";
import DeductDataService from "../../services/DeductDataService";
import CreditLunasiModal from "components/Modals/CreditLunasi";

class CreditHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      credits: [],
      cashbons: [],
      creditToBeDropped: {},
      cashbonToBeDropped: {},
    };
    this.creditDataService = new CreditDataService();
    this.deductDataService = new DeductDataService();
  }

  toggleModal = (state, formType, credit) => {
    this.setState({
      kreditId: credit?.kredit_id,
      [state]: !this.state[state],
      formType: formType,
    });
  };

  toggleModals = (state, credit) => {
    this.setState({
      [state]: !this.state[state],
      creditToBeDropped: credit,
    });
  };

  toggleDropCashbonModal = (state, cashbon) => {
    this.setState({
      [state]: !this.state[state],
      cashbonToBeDropped: cashbon,
    });
  };

  componentDidMount() {
    this.fetchData()
  }

  onKeyUp(e) {
    delete this.state.errorMessage;
    var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
    if (charCode === 13) {
      this.fetchData();
    }
  }

  handleSearch(e) {
    this.setState({ nik: e.target.value }, () => {
      this.fetchData();
    });
  }

  fetchData() {
    if (this.state.nik === undefined || this.state.nik === '') {
      return;
    }

    this.creditDataService.getCreditByNIK(this.state.nik)
      .then(res => {
        let totalAmount = 0;
        let totalCredits = 0;
        let totalInstallmentPerMonth = 0;
        let totalCashbons = 0;
        res.data?.kredit_list?.map((kredit) => {
          totalAmount += kredit.amount;
          totalCredits += kredit.total_kredit;
          totalInstallmentPerMonth += kredit.cicilan
        })

        res.data?.cashbon_list?.map((cashbon) => {
          if (cashbon.discounted_price == null) {
            totalCashbons += (cashbon.sell_price * cashbon.qty);
          } else {
            totalCashbons += (cashbon.discounted_price * cashbon.qty);
          }
        })

        this.setState({
          nik: res.data?.nik,
          name: res.data?.nama,
          creditValidated: true,
          credits: res.data?.kredit_list,
          cashbons: res.data?.cashbon_list,
          totalAmount: totalAmount,
          totalCredits: totalCredits,
          totalInstallmentPerMonth: totalInstallmentPerMonth,
          totalCashbons: totalCashbons,
        })
      })
  }

  handleLunasi(kreditId, reportId) {
    this.creditDataService.payOffCredit(reportId, kreditId)
      .then((res) => {
        if (res.errorMessage) {
          this.setState({ errorMessage: res.errorMessage });
        } else {
          this.setSuccessMessage('Kredit berhasil dilunasi.');
          this.fetchData();
        }

        this.toggleModal("formModal");
        setTimeout(() => {
          this.setState({ errorMessage: undefined, successMessage: undefined, })
        }, 5000);
      })
  }

  handleDrop() {
    this.creditDataService.dropCredit(this.state.creditToBeDropped.kredit_id)
      .then((res) => {
        if (res.errorMessage) {
          this.setState({ errorMessage: res.errorMessage });
        } else {
          this.setSuccessMessage('Kredit berhasil dihapus.')
          this.fetchData();
        }

        this.toggleModal("notificationModal");
        setTimeout(() => {
          this.setState({ errorMessage: undefined, successMessage: undefined, })
        }, 5000);
      })
  }

  handleDropCashbon() {
    this.deductDataService.deleteCashbon(this.state.cashbonToBeDropped.transaction_id)
      .then((res) => {
        if (res.errorMessage) {
          this.setState({ errorMessage: res.errorMessage });
        } else {
          this.setSuccessMessage('Cashbon berhasil dihapus.')
          this.fetchData();
        }

        this.toggleDropCashbonModal("dropCashbonModal");
        setTimeout(() => {
          this.setState({ errorMessage: undefined, successMessage: undefined, })
        }, 5000);
      })
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message })
  }

  render() {
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">

                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-3">
                    <Col xs={12}>
                      <FormGroup>
                        <InputGroup className="input-group-alternative mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-zoom-split-in" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            className="form-control-alternative"
                            placeholder="NIK"
                            onChange={this.handleSearch.bind(this)}
                            onKeyUp={this.onKeyUp.bind(this)}
                            type="text"
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardHeader>
                {(this.state.cashbons?.length > 0 || this.state.credits?.length > 0) && (
                  <CardBody>
                    <div>
                      <h6 className="heading-small text-muted mb-4">
                        Informasi karyawan
                      </h6>
                      <div className="pl-lg-4">
                        <Table className="align-items-center table-flush table-borderless" responsive>
                          <tbody>
                            <tr>
                              <th>
                                Nama karyawan
                              </th>
                              <td>
                                {this.state.name}
                              </td>
                            </tr>
                            <tr>
                              <th>
                                NIK karyawan
                              </th>
                              <td>
                                {this.state.nik}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <hr className="my-4" />
                      <h6 className="heading-small text-muted mb-4">
                        Riwayat kredit
                      </h6>
                      <div className="pl-lg-4">
                        <Table className="align-items-center table-flush" responsive>
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">Kredit</th>
                              <th scope="col">Nominal pinjaman</th>
                              <th scope="col">Total pinjaman</th>
                              <th scope="col">Cicilan per bulan</th>
                              <th scope="col">Tenor pinjaman</th>
                              <th scope="col">Tenor pinjaman berjalan</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.credits && this.state.credits.map((credit) => (
                              <tr>
                                <th>
                                  {credit.kredit_name}
                                </th>
                                <td>
                                  <NumberFormat
                                    value={credit.amount}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'Rp.'} suffix={',00'} />
                                </td>
                                <td>
                                  <NumberFormat
                                    value={credit.total_kredit}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'Rp.'} suffix={',00'} />
                                </td>
                                <td>
                                  <NumberFormat
                                    value={credit.cicilan}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'Rp.'} suffix={',00'} />
                                </td>
                                <td>
                                  {credit.total_installment}
                                </td>
                                <td>
                                  {credit.current_installment}
                                </td>
                                <td>
                                  {credit.approval_id === 0 && (
                                    <Button
                                      color="primary"
                                      type="button"
                                      onClick={() => this.toggleModal("formModal", "add", credit)}
                                      size="sm">
                                      Lunasi</Button>
                                  )}
                                  {(credit.approval_id == 0 && (localStorage.getItem("user_roles") || "")
                                    .split(',')
                                    .map(role => role.trim().toLowerCase())
                                    .some(role => role === "pengawas" || role === "admin")) && (
                                    <Button
                                      color="danger"
                                      type="button"
                                      onClick={() => this.toggleModals("notificationModal", credit)}
                                      size="sm">
                                      Hapus</Button>
                                  )}
                                  <Modal
                                    className="modal-dialog-centered modal-danger"
                                    contentClassName="bg-gradient-danger"
                                    isOpen={this.state.notificationModal}
                                    toggle={() => this.toggleModals("notificationModal")}
                                  >
                                    <div className="modal-header">
                                      <button
                                        aria-label="Close"
                                        className="close"
                                        data-dismiss="modal"
                                        type="button"
                                        onClick={() => this.toggleModals("notificationModal")}
                                      >
                                        <span aria-hidden={true}>×</span>
                                      </button>
                                    </div>
                                    <div className="modal-body">
                                      <div className="py-3 text-center">
                                        <i className="ni ni-bell-55 ni-3x" />
                                        <h4 className="heading mt-4">Anda akan menghapus kredit berikut</h4>
                                        <p>
                                          Nama kredit <b>{this.state.creditToBeDropped?.kredit_name}</b> <br />
                                          Nominal pinjaman <b><NumberFormat
                                            value={this.state.creditToBeDropped?.amount}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'Rp.'} suffix={',00'} /></b> <br />
                                          Total pinjaman <b><NumberFormat
                                            value={this.state.creditToBeDropped?.total_kredit}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'Rp.'} suffix={',00'} /></b> <br />
                                          Cicilan per bulan <b><NumberFormat
                                            value={this.state.creditToBeDropped?.cicilan}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'Rp.'} suffix={',00'} /></b>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="modal-footer">
                                      <Button
                                        className="text-white ml-auto"
                                        color="link"
                                        data-dismiss="modal"
                                        type="button"
                                        onClick={() => this.toggleModal("notificationModal")}
                                      >
                                        Batal
                                      </Button>
                                      <Button
                                        className="btn-white"
                                        color="default"
                                        type="button"
                                        onClick={() => this.handleDrop()}
                                      >
                                        Hapus
                                      </Button>
                                    </div>
                                  </Modal>
                                </td>
                              </tr>
                            ))}
                            <CreditLunasiModal
                              toggleModal={() => this.toggleModal("formModal")}
                              formModal={this.state.formModal}
                              formType={this.state.formType}
                              setSuccessMessage={this.setSuccessMessage}
                              handleLunasi={this.handleLunasi.bind(this)}
                              kreditId={this.state.kreditId}
                              nik={this.state.nik}
                              fetchData={this.fetchData}
                            />
                          </tbody>
                          <tfoot>
                            <tr>
                              <th><h3>Total</h3></th>
                              <td>
                                <h3><NumberFormat
                                  value={this.state.totalAmount}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'Rp.'} suffix={',00'} /></h3>
                              </td>
                              <td>
                                <h3><NumberFormat
                                  value={this.state.totalCredits}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'Rp.'} suffix={',00'} /></h3>
                              </td>
                              <td>
                                <h3><NumberFormat
                                  value={this.state.totalInstallmentPerMonth}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'Rp.'} suffix={',00'} /></h3>
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tfoot>
                        </Table>
                      </div>
                      <hr className="my-4" />
                      <h6 className="heading-small text-muted mb-4">
                        Riwayat Cashbon
                      </h6>
                      <div className="pl-lg-4">
                        <Table className="align-items-center table-flush" responsive>
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">Nama produk</th>
                              <th scope="col">Jumlah produk</th>
                              <th scope="col">Harga produk</th>
                              <th scope="col">Total Harga</th>
                              <th scope="col">Tgl Checkout</th>
                              <th scope="col">Status</th>
                              <th scope="col" />
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.cashbons && this.state.cashbons.map((cashbon) => (
                              <tr>
                                <th>
                                  {cashbon.product_name}
                                </th>
                                <td>
                                  {cashbon.qty}
                                </td>
                                <td>
                                  {(cashbon.discounted_price !== null) && (
                                    <span>
                                      <del>
                                        <NumberFormat
                                          value={cashbon.sell_price}
                                          displayType={'text'}
                                          thousandSeparator={true}
                                          prefix={'Rp.'} suffix={',00'} />
                                      </del><br />
                                      <NumberFormat
                                        value={cashbon.discounted_price}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'Rp.'} suffix={',00'} />
                                    </span>
                                  )}
                                  {(cashbon.discounted_price == null) && (
                                    <NumberFormat
                                      value={cashbon.sell_price}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'Rp.'} suffix={',00'} />
                                  )}
                                </td>
                                <td>
                                  <NumberFormat
                                    value={(cashbon.discounted_price > 0 ? (cashbon.discounted_price * cashbon.qty) : (cashbon.sell_price * cashbon.qty))}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'Rp.'} suffix={',00'} />
                                </td>
                                <td>
                                  {new Date(cashbon.created_at).toLocaleDateString()}
                                </td>
                                <td>
                                  <Badge
                                    color={cashbon.status === 0 ? "success" : "danger"}
                                  >
                                    {cashbon.status === 0 ? 'Lunas' : 'Belum lunas'}
                                  </Badge>
                                </td>
                                <td>
                                {((localStorage.getItem("user_roles") || "")
                                    .split(',')
                                    .map(role => role.trim().toLowerCase())
                                    .some(role => role === "pengawas" || role === "admin")) && (
                                    <Button
                                      color="danger"
                                      type="button"
                                      onClick={() => this.toggleDropCashbonModal("dropCashbonModal", cashbon)}
                                      size="sm">
                                      Hapus
                                      </Button>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <Modal
                            className="modal-dialog-centered modal-danger"
                            contentClassName="bg-gradient-danger"
                            isOpen={this.state.dropCashbonModal}
                            toggle={() => this.toggleDropCashbonModal("dropCashbonModal")}
                          >
                            <div className="modal-header">
                              <button
                                aria-label="Close"
                                className="close"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => this.toggleDropCashbonModal("dropCashbonModal")}
                              >
                                <span aria-hidden={true}>×</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <div className="py-3 text-center">
                                <i className="ni ni-bell-55 ni-3x" />
                                <h4 className="heading mt-4">Anda akan menghapus cashbon berikut</h4>
                                <p>
                                  Nama produk <b>{this.state.cashbonToBeDropped?.product_name}</b> <br />
                                  Total Harga <b><NumberFormat
                                    value={(this.state.cashbonToBeDropped?.discounted_price > 0 ? (this.state.cashbonToBeDropped?.discounted_price * this.state.cashbonToBeDropped?.qty) : (this.state.cashbonToBeDropped?.sell_price * this.state.cashbonToBeDropped?.qty))}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'Rp.'} suffix={',00'} /></b> <br />
                                  Status <b>{this.state.cashbonToBeDropped?.status === 0 ? 'Lunas' : 'Belum lunas'}</b><br />
                                </p>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <Button
                                className="text-white ml-auto"
                                color="link"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => this.toggleDropCashbonModal("dropCashbonModal")}
                              >
                                Batal
                              </Button>
                              <Button
                                className="btn-white"
                                color="default"
                                type="button"
                                onClick={() => this.handleDropCashbon()}
                              >
                                Hapus
                              </Button>
                            </div>
                          </Modal>
                          <tfoot>
                            <td>
                              <h3>Total</h3>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <h3>
                                <NumberFormat
                                  value={this.state.totalCashbons}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'Rp.'} suffix={',00'} />
                              </h3>
                            </td>
                            <td></td>
                          </tfoot>
                        </Table>
                      </div>
                    </div>
                  </CardBody>
                )}
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default CreditHistory;
